<template>
    <div class="content-page">
        <div class="tab-header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>运费服务</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="flex-row-between">
            <div>
                <button class="zent-btn-primary zent-btn" @click="addNewTemplate">新建运费模板</button>
            </div>
            <div class="flex-row-end">
                <el-input placeholder="按运费模板名称进行查找" v-model="settingName" />
                <button class="zent-btn-primary zent-btn" @click="search">搜索</button>
            </div>
        </div>
        <div class="tab-content">
            <div class="frieght-list" v-if="freightList.length > 0">
                <ul>
                    <li v-for="(item, index) in freightList" :key="item">
                        <div class="list-item">  
                            <div class="list-header" @click="show_detail(index, item)">
                                <div>{{item.settingName}}</div>
                                <div class="operate-list">
                                    <span class="lastEdit-time">最后编辑时间：{{item.modifyTime}}</span>
                                    <el-button type="text" @click.stop="updateTemplate(item, index)">修改</el-button>
                                    <el-button type="text" @click.stop="deleteTemplate(item)">删除</el-button>
                                    <div :class="{ active: item.isShow }" class="triggle-down"></div>
                                </div>
                            </div>
                            <div v-if="item.isShow">
                                <table class="zent-grid-table">
                                    <thead class="zent-grid-thead">
                                        <tr>
                                            <th>可配送区域</th>
                                            <th>首件(个)</th>
                                            <th>运费(元)</th>
                                            <th>续件(个)</th>
                                            <th>续费(元)</th>
                                        </tr>
                                        <tr v-for="item1 in item.newArr" :key="item1">
                                            <td>{{item1.addressProvinceName}}</td>
                                            <td>{{item1.startStandard}}</td>
                                            <td>{{item1.startPrice}}</td>
                                            <td>{{item1.addStandard}}</td>
                                            <td>{{item1.addPrice}}</td>
                                        </tr>
                                        <!-- <tr v-if="item.newArr.length <= 0">
                                            <td style="text-align:center;">暂无数据</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr> -->
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else>
                暂无数据
            </div>
        </div>
        <div
            v-if="freightList.length > 0"
            class="block"
            style="float:right;margin-top:10px;margin-right:30px;"
        >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { getDeliveryList, getDeliverySettingRule, deleteDeliverySettingRule } from '../api/index'
export default {
    data() {
        return {
            settingName: "",
            pageNo: 1,
            total: 0,
            freightList: [],
            freightDetail: [],
            status: ""
        }
    },
    mounted() {
        this.getDeliveryList()
    },
    methods: {
        getDeliveryList(settingName) {
            getDeliveryList({
                pageNo: this.pageNo,
                pageSize: 10,
                settingName: settingName
            })
            .then(res => {
                if (res.code == 1) {
                    this.freightList = res.data
                    this.total = this.freightList.length
                    // this.freightList.forEach((item, index) => {
                    //     this.getDeliverySettingRule(this.freightList[index].id, index)
                    // })
                    this.freightList.forEach(item => {
                        this.$set(item, 'isShow', false)
                        this.$set(item, 'newArr', [])
                        // this.$set(this.freightList[0], 'isShow', true)
                    })
                } else if (res.code == -1) {
                    this.freightList = []
                }
            })
        },
        handleCurrentChange(val) {
            this.pageNo = val
            if (this.status == 1) {
                this.getDeliveryList(this.settingName)
            } else {
                this.getDeliveryList()
            }
        },
        search() {
            this.status = 1
            this.getDeliveryList(this.settingName)
        },
        getDeliverySettingRule(id, index) {
            getDeliverySettingRule({
                deliverySettingId: id
            })
            .then(res => {
                if (res.code == 1) {
                    this.freightList[index].newArr = res.data.deliverySettingRuleList
                } else if (res.code == -1) {
                    this.freightList[index].newArr = []
                }
            })
        },
        show_detail(index, item) {
            console.log(index, item.id)
            var that = this
            var listData = that.freightList 
            var isShow = that.freightList[index].isShow // 先用一个变量接收一个原来的状态值
            if (!isShow) {
                this.getDeliverySettingRule(item.id, index)
            }
            listData[index].isShow = !isShow
            that.freightList = listData
        },
        updateTemplate(item, index) {
            console.log(item, index)
            sessionStorage.setItem("id", JSON.stringify(item.id))
            this.$router.push('/setting/addFreightTmplate')
        },
        deleteTemplate(item) {
            console.log(item)
            this.$confirm("此操作将永久删除该模板, 是否继续", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: 'warning'
            }).then(({value}) => {
                deleteDeliverySettingRule({
                    deliverySettingId: item.id
                })
                .then(res => {
                    if (res.code == 1) {
                        this.$notify({
                            title: "提示",
                            message: "删除成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.getDeliveryList()
                    }
                })
            })
        },
        addNewTemplate() {
            this.$router.push('/setting/addFreightTmplate')
            sessionStorage.removeItem("id")
        }
    }
};
</script>

<style lang="less" scoped>
.zent-btn-primary {
    border-color: var(--theme-primary-4,#155bd4);
    background-color: var(--theme-primary-4,#155bd4);
}
.zent-btn {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    border: 1px solid #dcdee0;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .3s;
    color: #fff;
}
button {
    appearance: none;
    border: none;
    background-color: transparent;
    outline: none;  
}
.content-page {
    .tab-header {
        padding: 12px 20px;
    }
    .flex-row-between {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 20px 20px 0;
        .flex-row-end {
            width: 300px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }
    .tab-content {
        padding: 40px 20px;
        .frieght-list {
            width: 100%;
            height: 500px;
            max-height: calc(100vh - 320px);
            overflow-y: scroll;
            .list-item {
                .list-header {
                    background: #F7F8FA;
                    height: 52px;
                    line-height: 52px;
                    padding: 0 18px;
                    width: calc(100vw - 280px);
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    border: 1px solid #ebedf0;
                    margin-bottom: -1px;
                    cursor: pointer;
                    .operate-list {
                        width: 350px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        .lastEdit-time {
                            font-size: 14px;
                            color: #999;
                        }
                        .triggle-down {
                            width: 6px;
                            height: 6px;
                            border-top: 1px solid #4F4F4F;
                            border-right: 1px solid #4F4F4F;
                            margin-top: 21px;
                            transform: rotate(135deg);
                            &.active {
                                margin-top: 25px;
                                transform: rotate(-45deg);
                            }
                        }
                    }
                }
                .zent-grid-table {
                    width: 100%;
                    text-align: left;
                    border-collapse: collapse;
                    border-spacing: 0;
                    .zent-grid-thead {
                        width: 100%;
                        tr {
                            display: table-row;
                            background-color: var(--theme-stroke-9,#fff);
                            height: 56px;
                            line-height: 56px;
                            color: var(--theme-stroke-1,#323233);
                            border-bottom: 1px solid #ebedf0;
                            border-bottom-color: var(--theme-stroke-6,#ebedf0);
                            th {
                                font-size: 14px;
                                display: table-cell;
                                box-sizing: border-box;
                                // border-bottom: 1px solid #ebedf0;
                                // border-bottom-color: var(--theme-stroke-6,#ebedf0);
                                vertical-align: middle;
                                text-align: right;
                                &:first-child {
                                    text-align: left;
                                    padding-left: 18px;
                                    width: 60%;
                                }
                                &:last-child {
                                    padding-right: 18px;
                                }
                            }
                            td {
                                padding: 0 18px;
                                text-align: right;
                                &:first-child {
                                    text-align: left;
                                }
                            }
                        }
                    }
                }   
            }
        }
    }
}
/deep/ .el-input {
    width: 76%;
}
</style>
